var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Checkbox } from "../controls";
import { SPACING_M } from "./const";
import { Menu, MenuItem } from "../Menu";
var MAX_HEIGHT_MENU = '560px';
var StyledCheckbox = styled(Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: 100%;\n"], ["\n    padding-left: ", ";\n    padding-right: ", ";\n    width: 100%;\n"])), SPACING_M, SPACING_M);
var StyledMenuItem = styled(MenuItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-left: 0;\n    padding-right: 0;\n"], ["\n    padding-left: 0;\n    padding-right: 0;\n"])));
export var ToggleMenuItem = function (_a) {
    var title = _a.title, isChecked = _a.isChecked, onChange = _a.onChange, rest = __rest(_a, ["title", "isChecked", "onChange"]);
    return (React.createElement(StyledMenuItem, __assign({}, rest, { onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(!isChecked); } }),
        React.createElement(StyledCheckbox, { checked: isChecked }, title)));
};
export var ToggleMenu = styled(Menu)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-height: ", ";\n    overflow-y: auto;\n"], ["\n    max-height: ", ";\n    overflow-y: auto;\n"])), MAX_HEIGHT_MENU);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ToggleMenu.js.map